import React, { Component } from 'react'
import { getBranchesLatest } from '../../store/actions'
import withRouter from '../lib/withRouter'
import { connect } from 'react-redux'
import Authentication from '../../session';
import Service from '../services'
import { BasicLazyParams } from '../../utile';
import BranchToSectionMultiDDTillSecReports from '../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports';
import { baseUrlAdmin } from '../../store/apiConstants';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from 'primereact/multiselect';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import * as XLSX from 'xlsx';
import "./styles.scss"
import moment from 'moment';
class FeeDueReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      dropdownsData: {},
      feeType: [],
      lazyParams: BasicLazyParams,
      feeDueReport: [],
      originalFeeDueReport: [], // Store original data for filtering
      totalRecords: 0,
      visibleColumns: [], // For column toggle functionality
      isLiveLoading: false // For Live button loading state
    }
    this.service = new Service()

    // Available additional columns
    this.columns = [
      { field: 'branchName', header: 'Branch' },
      { field: 'boardName', header: 'Board' },
      { field: 'contactPersonName', header: 'Contact Person' },
      { field: 'parentContactNo', header: 'Parent Contact' },
      { field: 'admissionCategoryName', header: 'Admission Category' }
    ];
  }

  async componentDidMount() {
    // Load initial data without filters
    this.getFeeDueReportInfo();
  }


  setDropdownValues = (dropdownsData) => {
    const branchChanged = this.state.dropdownsData?.branchIds !== dropdownsData.branchIds;
    const boardChanged = this.state.dropdownsData?.boardIds !== dropdownsData.boardIds;
    const classChanged = this.state.dropdownsData?.classIds !== dropdownsData.classIds;
    const sectionChanged = this.state.dropdownsData?.sectionIds !== dropdownsData.sectionIds;
    
    // Check if any key dropdown changed
    const keyDropdownChanged = branchChanged || boardChanged || classChanged || sectionChanged;
    
    this.setState({
      dropdownsData,
      branchChanged,
      // Clear dependent selections when key dropdowns change
      ...(keyDropdownChanged && {
        selectedFeeStructure: null,
        feeStructuresArray: [],
        feeTypes: [],
        feeType: [],
        selectedPaymentTerms: [],
        paymentTerms: [],
        planId: null
      })
    }, () => {
      if (this.state.branchChanged && this.state.dropdownsData.branchIds) {
        this.getFeeStructures();
      }
      // Apply frontend filtering instead of API call
      this.applyDropdownFiltering();
    });
  }

  getFeeDueReportInfo = async () => {
    let { globalSearch } = this.state;
    this.setState({
      isLoading: true,
    });
    let url = `${baseUrlAdmin}/financeReports/feeDueReport?search=${globalSearch || ''}`;
    let payload = {
      academicYear: localStorage.getItem('userAcademicYear'),
      branchIds: this.state.dropdownsData?.branchIds,
      sectionIds: this.state.dropdownsData?.sectionIds,
      boardIds: this.state.dropdownsData?.boardIds,
      classIds: this.state.dropdownsData?.classIds,
      feeStructureId: this.state.selectedFeeStructure,
      feeTypes: this.state.feeType,
      installmentId: this.state.selectedPaymentTerms,
    }
    this.service.post(url, payload, true).then(data => {
      if (data.status) {
        if (data?.res?.status) {

          this.setState({
            feeDueReport: data?.res?.data,
            originalFeeDueReport: data?.res?.data, // Store original data
            totalRecords: data?.res?.totalRecords || (data?.res?.data?.length || 0),
            isLoading: false
          })
        } else {
          this.setState({
            isLoading: false
          })
        }
      } else {
        this.setState({
          isLoading: false
        })
      }
    });
  }

  applyDropdownFiltering = () => {
    const {
      originalFeeDueReport,
      dropdownsData,
      selectedFeeStructure,
      feeType,
      selectedPaymentTerms
    } = this.state;

    if (!originalFeeDueReport || originalFeeDueReport.length === 0) {
      return;
    }

    let filteredData = [...originalFeeDueReport];

    // Filter by branch
    if (dropdownsData?.branchIds && dropdownsData.branchIds.length > 0) {
      filteredData = filteredData.filter(item =>
        dropdownsData.branchIds.includes(item.branchId)
      );
    }

    // Filter by board
    if (dropdownsData?.boardIds && dropdownsData.boardIds.length > 0) {
      filteredData = filteredData.filter(item =>
        dropdownsData.boardIds.includes(item.boardId)
      );
    }

    // Filter by class
    if (dropdownsData?.classIds && dropdownsData.classIds.length > 0) {
      filteredData = filteredData.filter(item =>
        dropdownsData.classIds.includes(item.classId)
      );
    }

    // Filter by section
    if (dropdownsData?.sectionIds && dropdownsData.sectionIds.length > 0) {
      filteredData = filteredData.filter(item =>
        dropdownsData.sectionIds.includes(item.sectionId)
      );
    }

    // Filter by fee structure
    if (selectedFeeStructure) {
      filteredData = filteredData.filter(item => {
        if (!item.feeTypes || !Array.isArray(item.feeTypes)) return false;
        return item.feeTypes.some(feeTypeItem =>
          feeTypeItem.feeStructureId === selectedFeeStructure
        );
      });
    }

    // Filter by fee types
    if (feeType && feeType.length > 0) {
      filteredData = filteredData.filter(item => {
        if (!item.feeTypes || !Array.isArray(item.feeTypes)) return false;
        return item.feeTypes.some(feeTypeItem =>
          feeType.includes(feeTypeItem.feeTypeId)
        );
      });
    }

    // Filter by installments
    if (selectedPaymentTerms && selectedPaymentTerms.length > 0) {
      filteredData = filteredData.filter(item =>
        selectedPaymentTerms.includes(item._id?.installmentId)
      );
    }

    this.setState({
      feeDueReport: filteredData,
      totalRecords: filteredData.length
    });
  }

  // Method to refresh data from API when needed
  refreshDataFromAPI = () => {
    this.getFeeDueReportInfo();
  }

  // Method to fetch live data and cache in Redis
  fetchLiveData = async () => {
    this.setState({
      isLiveLoading: true,
    });

    try {
      let url = `${baseUrlAdmin}/financeReports/feeDueReport?live=true`; let payload = {
        academicYear: localStorage.getItem('userAcademicYear'),
        orgId: localStorage.getItem('orgId'), // Assuming orgId is stored in localStorage
        branchIds: this.state.dropdownsData?.branchIds,
        sectionIds: this.state.dropdownsData?.sectionIds,
        boardIds: this.state.dropdownsData?.boardIds,
        classIds: this.state.dropdownsData?.classIds,
        feeStructureId: this.state.selectedFeeStructure,
        feeTypes: this.state.feeType,
        installmentId: this.state.selectedPaymentTerms,
      }

      const data = await this.service.post(url, payload, true);

      if (data.status) {
        if (data?.res?.status) {
          this.setState({
            feeDueReport: data?.res?.data,
            originalFeeDueReport: data?.res?.data, // Store original data
            totalRecords: data?.res?.totalRecords || (data?.res?.data?.length || 0),
            isLiveLoading: false
          }, () => {
            // Apply filtering to the newly fetched live data
            this.applyDropdownFiltering();
          });

          this.toast.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Live data fetched and cached successfully',
            life: 3000
          });
        } else {
          this.setState({
            isLiveLoading: false
          });
          this.toast.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to fetch live data',
            life: 3000
          });
        }
      } else {
        this.setState({
          isLiveLoading: false
        });
        this.toast.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch live data',
          life: 3000
        });
      }
    } catch (error) {
      console.error('Live data fetch error:', error);
      this.setState({
        isLiveLoading: false
      });
      this.toast.show({
        severity: 'error',
        summary: 'Error',
        detail: 'An error occurred while fetching live data',
        life: 3000
      });
    }
  }

  onPage = (event) => {
    this.setState({
      lazyParams: {
        ...this.state.lazyParams,
        first: event.first,
        rows: event.rows
      }
    });
  }

  getFeeStructures = async () => {
    this.setState({
      isLoading: true
    });
    let academicYear = localStorage.getItem('userAcademicYear');
    let payload = {
      academicYear: academicYear,
      branchId: this.state.dropdownsData.branchIds
    }
    let url = `${baseUrlAdmin}/fee-structure/reports`;
    this.service.post(url, payload, true).then((data) => {
      if (data.status) {
        if (data.res.status && data?.res?.data) {
          this.setState({
            feeStructuresArray: data?.res?.data?.response || [],
            isLoading: false
          },);
        } else {
          this.setState({
            isLoading: false
          });
        }
      } else {
        this.setState({
          isLoading: false
        });
      }
    });
  };
  getFeeInstallments = async () => {
    const academicYear = localStorage.getItem('userAcademicYear');
    this.setState({ isLoading: true });
    let url = `${baseUrlAdmin}/feeInstallments/${this.state?.planId}?academicYear=${academicYear}`;
    try {
      const res = await this.service.get(url, true);
      if (res?.res?.status && res.status) {
        this.setState({ paymentTerms: res?.res?.data, isLoading: false });
      } else {
        this.setState({ isLoading: false });
        this.toast.show({ severity: 'error', summary: 'Error', detail: res?.message, life: 3000 });
      }
    } catch (e) {
      console.log(e);
      this.setState({ isLoading: false });
      this.toast.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 });
    }
  };

  dynamicColumns = (feeTypes, selectedFeeTypes) => {
    if (selectedFeeTypes && selectedFeeTypes.length) {
      feeTypes = feeTypes.filter(each => selectedFeeTypes.includes(each.id));
    }
    let feeInfo = feeTypes;

    let columns = [];

    feeInfo.forEach((each, index) => {
      // Column for Total Amount
      columns.push(
        <Column
          key={`total-${each.feeType}-${index}`}
          style={{ width: "15rem", height: "6rem" }}
          filterField={`total-${each.feeType}`}

          bodyClassName='text-center'
          header={`Total ${each.feeType}`}
          alignHeader={"center"}
          body={(rowData) => {
            const feeTypeData = rowData.feeTypes?.find(fee => fee.feeType === each.feeType);
            return <p>{feeTypeData?.termWiseActualValue || 0}</p>;
          }}
        />
      );

      // Column for Due Amount
      columns.push(
        <Column
          key={`due-${each.feeType}-${index}`}
          style={{ width: "15rem", height: "6rem" }}
          filterField={`due-${each.feeType}`}

          bodyClassName='text-center'
          header={`${each.feeType} Due`}
          alignHeader={"center"}
          body={(rowData) => {
            const feeTypeData = rowData.feeTypes?.find(fee => fee.feeType === each.feeType);
            const dueAmount = (feeTypeData?.termWiseActualValue || 0) - (feeTypeData?.amountPaid || 0);
            return <p>{dueAmount}</p>;
          }}
        />
      );
    });

    return columns;
  }

  downloadExcel = () => {
    const { feeDueReport, feeTypes, feeType } = this.state;

    if (!feeDueReport || !feeDueReport.length) {
      this.toast.show({
        severity: 'warn',
        summary: 'Warning',
        detail: 'No data available to download',
        life: 3000
      });
      return;
    }

    // Prepare the data for export
    const exportData = feeDueReport.map(row => {
      let data = {
        'Student Id': row.username ? row.username.slice(3) : '',
        'Student Name': row.firstName && row.lastName ? `${row.firstName} ${row.lastName}` : row.given_name || '',
        'Fee Term': row.installmentTitle || '',
        'Class-Section': `${row.className || ''}-${row.sectionName || ''}`,
        'Date': row.dueDate ? moment(row.dueDate).format("DD/MM/YYYY") : '',
        'Total Fee': row.totalTermAmount || 0,
        'Fee Paid': row.totalAmountPaid || 0,
        'Due Fee': (row.totalTermAmount || 0) - (row.totalAmountPaid || 0),
      };

      // Add dynamic additional columns based on user selection
      if (this.state.visibleColumns.includes('branchName')) {
        data['Branch'] = row.branchName || '';
      }
      if (this.state.visibleColumns.includes('boardName')) {
        data['Board'] = row.boardName || '';
      }

      if (this.state.visibleColumns.includes('contactPersonName')) {
        data['Contact Person'] = row.contactPersonName || '';
      }
      if (this.state.visibleColumns.includes('parentContactNo')) {
        data['Parent Contact'] = row.parentContactNo || '';
      }
      if (this.state.visibleColumns.includes('admissionCategoryName')) {
        data['Admission Category'] = row.admissionCategoryName || '';
      }

      // Add dynamic fee type columns - safely handle undefined feeTypes
      if (feeTypes && Array.isArray(feeTypes)) {
        const selectedFeeTypes = feeType && feeType.length ?
          feeTypes.filter(each => feeType.includes(each.id)) :
          feeTypes;

        selectedFeeTypes.forEach(feeTypeItem => {
          if (feeTypeItem && feeTypeItem.feeType) {
            const feeTypeData = row.feeTypes?.find(fee => fee.feeType === feeTypeItem.feeType);
            data[`Total ${feeTypeItem.feeType}`] = feeTypeData?.termWiseActualValue || 0;
            data[`${feeTypeItem.feeType} Due`] = (feeTypeData?.termWiseActualValue || 0) - (feeTypeData?.amountPaid || 0);
          }
        });
      }

      return data;
    });

    try {
      // Create worksheet and workbook
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Fee Due Report');

      // Generate and download file
      XLSX.writeFile(wb, 'FeeDueReport.xlsx');
    } catch (error) {
      console.error('Excel export error:', error);
      this.toast.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to download report',
        life: 3000
      });
    }
  };

  render() {
    return (
      <>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: '0',
          marginLeft: "100px",
          marginTop: "55px",
          overflow: 'auto',

        }}>
          <div className="card filters-card mt-1 pt-0 ml-0">
            <BranchToSectionMultiDDTillSecReports setValues={this.setDropdownValues} />
            <div className="grid m-2 ml-0">
              <div className="col-3 ">
                <label className='label'>Fee Structure</label>
                <div className="mt-2">
                  <ClassetDropdown
                    options={this.state.feeStructuresArray}
                    value={this.state.selectedFeeStructure}
                    optionValue='_id'
                    optionLabel='scheduleName'
                    onChange={(e) => {
                      const selectedStructure = this.state.feeStructuresArray.find(each => each._id === e.target.value);
                      const feeTypes = selectedStructure?.stepOne?.map(each => ({
                        id: each.feeTypeId,
                        feeType: each.feeType
                      })) || [];

                      this.setState({
                        selectedFeeStructure: e.target.value,
                        feeTypes: feeTypes,
                        feeType: [],
                        planId: selectedStructure?.planId
                      }, () => {
                        // Apply frontend filtering only
                        this.applyDropdownFiltering();
                        if (this.state.planId) {
                          this.getFeeInstallments();
                        }
                      });
                    }}
                    placeholder={(
                      <div>
                        <span className=''>Select Fee Structure</span>
                      </div>
                    )}
                  />
                </div>
              </div>
              <div className="col-3 ">
                <label className='label'>Fee Types</label>
                <div className="mt-2">
                  <ClassetMultiSelect
                    options={this.state.selectedFeeStructure && this.state.feeTypes}
                    value={this.state.feeType}
                    optionValue='id'
                    optionLabel='feeType'
                    onChange={(e) => this.setState({ feeType: e.target.value }, () => {
                      // Apply frontend filtering only
                      this.applyDropdownFiltering();
                    })}
                    placeholder={(
                      <div>
                        <span className=''>Select Fee Type</span>
                      </div>
                    )}
                  />
                </div>
              </div>
              <div className="col-3 ">
                <label className='label'>Installments</label>
                <div className="mt-2">
                  <ClassetMultiSelect
                    options={this.state.paymentTerms}
                    value={this.state.selectedPaymentTerms}
                    optionValue='installmentId'
                    optionLabel='name'
                    onChange={(e) => this.setState({ selectedPaymentTerms: e.target.value }, () => {
                      // Apply frontend filtering only
                      this.applyDropdownFiltering();
                    })}
                    placeholder={(
                      <div>
                        <span className=''>Select Fee Installments</span>
                      </div>
                    )}
                  />
                </div>
              </div>
              <div className="col-3 mt-5 flex justify-content-end align-items-center gap-5 ms-auto" style={{ maxWidth: 'fit-content' }}>
                <Button
                  label="Download Report"
                  style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                  onClick={this.downloadExcel}
                />
                <Button label="View Analysis" className="p-button-primary"
                  style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff", }} />
              </div>
            </div>
          </div>
          <div className='datatable-report-demo mx-2'>
            <div className="flex justify-content-end mb-3">
              <div className="flex align-items-center  mr-3">
                <Button
                  label="Live"
                  icon="pi pi-refresh"
                  loading={this.state.isLiveLoading}
                  onClick={this.fetchLiveData}
                  className="p-button-success"
                  style={{
                    height: "35px",
                    padding: "10px 20px",
                    borderRadius: "8px",
                    backgroundColor: "#076EFF",
                    color: "#fff",
                    border: "1px solid #076EFF"
                  }}
                />
              </div>
              <div className="flex align-items-center">
                <label className="mr-2 font-semibold">Show More Fields:</label>
                <MultiSelect
                  value={this.state.visibleColumns}
                  options={this.columns}
                  optionLabel="header"
                  optionValue="field"
                  onChange={(e) => this.setState({ visibleColumns: e.value })}
                  placeholder="Select Fields"
                  display="chip"
                  style={{ minWidth: '200px', maxWidth: '200px' }}
                />
              </div>
            </div>
            <DataTable
              value={this.state.feeDueReport}
              dataKey="id"
              paginator
              responsiveLayout="scroll"
              columnResizeMode="expand"
              resizableColumns
              scrollable
              onPage={this.onPage}
              first={this.state.lazyParams.first}
              rows={this.state.lazyParams.rows}
              totalRecords={this.state.totalRecords}
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
              globalFilter={this.state.globalFilter}
              className="resizable-columns-table"
            >
              <Column

                filterField="username"
                field="username"
                header="Student Id"

                body={(rowData) => <p>{rowData?.username.slice(3)}</p>}
              />
              <Column
                filterField="firstName"
                header="Student Name"
                body={(rowData) => (
                  <div >
                    {(rowData?.firstName && rowData?.lastName)
                      ? `${rowData?.firstName} ${rowData?.lastName}`
                      : rowData.given_name}
                  </div>
                )}
              />
              <Column


                filterField="installmentTitle"
                field="installmentTitle"


                header="Fee Term"

              />
              {this.state.visibleColumns.includes('branchName') && (
                <Column
                  field="branchName"
                  header="Branch"
                  body={(rowData) => (
                    <p>{rowData?.branchName || '-'}</p>
                  )}
                />
              )}
              {this.state.visibleColumns.includes('boardName') && (
                <Column
                  field="boardName"
                  header="Board"
                  body={(rowData) => (
                    <p>{rowData?.boardName || '-'}</p>
                  )}
                />
              )}
              <Column

                filterField="className"
                field="username"


                header="Class-Section"

                body={(rowData) => (
                  <p>{`${rowData?.className}-${rowData?.sectionName}`}</p>
                )}
              />
              {/* Dynamic additional columns */}

              {this.state.visibleColumns.includes('contactPersonName') && (
                <Column
                  field="contactPersonName"
                  header="Contact Person"
                  body={(rowData) => (
                    <p>{rowData?.contactPersonName || '-'}</p>
                  )}
                />
              )}
              {this.state.visibleColumns.includes('parentContactNo') && (
                <Column
                  field="parentContactNo"
                  header="Parent Contact"
                  body={(rowData) => (
                    <p>{rowData?.parentContactNo || '-'}</p>
                  )}
                />
              )}
              {this.state.visibleColumns.includes('admissionCategoryName') && (
                <Column
                  field="admissionCategoryName"
                  header="Admission Category"
                  body={(rowData) => (
                    <p>{rowData?.admissionCategoryName || '-'}</p>
                  )}
                />
              )}
              <Column
                filterField="dueDate"
                sortable
                sortField='dueDate'
                field="dueDate"
                header="Date"
                body={(rowData) => (
                  <p>{rowData?.dueDate ? moment(rowData.dueDate).format("DD/MM/YYYY") : "-"}</p>
                )}
              />
              <Column

                filterField="totalTermAmount"
                field="totalTermAmount"


                header="Total Fee"

              />
              <Column

                filterField="totalAmountPaid"
                field="totalAmountPaid"


                header="Fee Paid"

              />
              <Column

                filterField="username"
                field="username"
                header="Due Fee"

                body={(rowData) => (
                  <p>{(rowData?.totalTermAmount - rowData?.totalAmountPaid).toFixed(2)}</p>
                )}
              />

              {this.state.selectedFeeStructure && this.dynamicColumns(this.state.feeTypes, this.state.feeType)}
            </DataTable>
          </div>
        </div>
        {this.state.isLoading && <LoadingComponent />}
        <Toast ref={(el) => this.toast = el} position="bottom-right" />

      </>
    )
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.boardsData.loading,
  isBranchLoading: state.branchDataLatest.isLoading,
  branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
  branchData:
    (state.branchDataLatest &&
      state.branchDataLatest.data &&
      state.branchDataLatest.data.data.filter((each) => {
        if (each.level == 1) {
          return { ...each };
        }
      })) ||
    [],
  _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStateToProps, {
  getBranchesLatest
})(Authentication(withRouter(FeeDueReport)));
